<div style="width: 100%" class="d-flex flex-column">
  <h2>{{ title }}</h2>
  <p style="text-align: justify">
    இந்த கணக்கீட்டு ஆய்வில் பதிவு செய்யப்படும் தனிநபர் தகவல்களின் உரிமை
    காக்கப்படும். உங்களின் கருத்துகள் தனிநபர் புகாராக எடுத்துக் கொள்ளப்படாது,
    கட்சியை மேன்மேலும் வலுப்படுத்த ஆலோசனைகளாகவும், அனுபவமாகவும் எடுத்துக்
    கொள்ளப்படும். தகவல்கள் அனைத்தும் தொகுக்கப்பட்டு பிரச்சனைகளுக்கு பொது தீர்வை
    எட்டுவதற்கு பயன்படுத்தப்படும். மேலும் கட்சியை வலுப்படுத்தி
    அடுத்தக்கட்டத்திற்கு நகர்த்த உங்களின் தகவல்களை நம்பிக்கையுடன் கட்டாயம் பதிவு
    செய்யவும்.
  </p>
  <p style="text-align: left">- நன்றி. செயற்களம்</p>
  <button
    style="align-self: center"
    (click)="onSubmit()"
    mat-raised-button
    class="bg-success"
  >
    தொடர்க
  </button>
</div>
